
  import { computed, defineComponent, ref, watch } from 'vue';
  import * as qs from '@/ui/queryState';
  import { useTask } from '@/ui/concerns';
  import { list as getTemplateCategories } from '@/services/api/resources/template/category/actions';
  import { templateCategory, templates } from '@/ui/auth/templates';
  import { list as getTemplates } from '@/services/api/resources/template/actions';
  import { useInfiniteScroll } from '@/ui/pages/useInfiniteScroll';
  import { Loader } from '@/ui/components/Loader';
  import { DropdownField, InputField } from '@/ui/components/form';
  import { v4 as uuidv4 } from 'uuid';

  export default defineComponent({
    name: 'NewFilters',
    components: {
      Loader,
      InputField,
      DropdownField,
    },
    setup(_, ctx) {
      const totalPages = ref(1);
      const currentPage = ref(1);
      const name = qs.string('search', '');
      const industry = qs.string('industry', '');
      const industries = computed(() => templateCategory.value.map(c => ({ label: c.title, value: c.slug })));
      const getInitialFilters = useTask(
        () => getTemplateCategories(),
        templateCategories => {
          templateCategory.value = templateCategories.data;
        },
      );
      const getTemplatesTask = useTask(
        () => getTemplates({ search: name.value, category: industry.value, page: currentPage.value.toString() }),
        templatesResponse => {
          ctx.emit('fetching:templates', false);
          templates.value = [...templates.value, ...templatesResponse.data];
          currentPage.value = templatesResponse.meta.current_page;
          totalPages.value = templatesResponse.meta.last_page;
        },
        uuidv4(),
        () => {
          ctx.emit('fetching:templates', false);
        },
      );

      const { onFilterChange } = useInfiniteScroll({
        bottomOffset: 400,
        containerSelector: 'window',
        task: getTemplatesTask,
        resources: templates,
        totalPages,
        currentPage,
      });

      watch([name, industry], () => {
        ctx.emit('fetching:templates', true);
        onFilterChange();
        getTemplatesTask.run();
      });

      getTemplatesTask.run();
      getInitialFilters.run();

      return {
        getTemplatesTask,
        totalPages,
        currentPage,
        name,
        industry,
        industries,
      };
    },
  });
